import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';

/**
 * Shared save-result handling for the company and section forms: surface a
 * conflict-aware error toast, or notify + navigate away on success.
 */
export function useFormSubmitHandlers(redirectTo: string) {
  const { navigationHandler, notificationHandler } = useHandlers();

  const onError = (err: unknown) => {
    const status = (err as { response?: { status?: number } })?.response?.status;
    const message = status === 409 ? t('errors:conflict') : t('errors:generic');
    notificationHandler.error(message);
  };

  const onSuccess = () => {
    notificationHandler.success(t('notifications:saved'));
    navigationHandler.navigate(redirectTo);
  };

  return { onError, onSuccess };
}
